import type { MuiTelInputCountry } from 'mui-tel-input';
import { FormType } from '@/__generated__/types';

export const POS_INQUIRY_BUSINESS_TYPES = [
    'Restaurant',
    'Café',
    'Bubble Tea / Dessert Shop',
    'Retail Store',
    'Bar / Pub',
    'Bakery',
    'Food Stall / Hawker',
    'Beauty / Salon',
    'Other'
] as const satisfies readonly string[];

export const POS_INQUIRY_HEARD_FROM_OPTIONS = [
    'Social Media',
    'Referral',
    'Walk-in / Event',
    'Existing Merchant',
    'Advertisement',
    'Other'
] as const satisfies readonly string[];

export const POS_INQUIRY_OTHER_BUSINESS_TYPE = 'Other';

export const POS_INQUIRY_DEFAULT_PHONE_COUNTRY: MuiTelInputCountry = 'AU';

export const POS_INQUIRY_INITIAL_VALUES = {
    formType: FormType.NewMerchant,
    restaurantName: '',
    contactName: '',
    mobileCountry: POS_INQUIRY_DEFAULT_PHONE_COUNTRY,
    mobileNumber: '',
    email: '',
    city: '',
    businessType: '',
    message: '',
    referralSource: ''
} as const;
